import React, { useContext, useEffect } from "react";
import ProtectedRoute from "../App";
import Stack from "@mui/material/Stack";
import UserMenu, { UserMenuTop, UserMenuTopPublic } from "./UserMenu";
import { AccountContext } from "./AccountProvider";
import { useNavigate } from "react-router-dom";
import { SiteBreadcrumbs } from "./Breadcrumbs";
import { Features } from "../games/features";
import Box from "@mui/material/Box";
import { QuickSearch } from "../QuickSearch";

/**
 * @param {object} props
 * @param {(() => React.JSX.Element)|string|null} [props.UnauthenticatedView]
 * @param {(() => React.JSX.Element)|null} [props.DesignerView]
 * @param {(() => React.JSX.Element)|string|null} [props.PublisherView]
 * @param {import("react").ReactNode} [props.children]
 */
export const AppWithSideMenu = ({
  children,
  UnauthenticatedView = null,
  DesignerView = null,
  PublisherView = null,
}) => {
  const { mode } = useContext(AccountContext);
  const navigate = useNavigate();

  const ViewToDisplay = mode === "Designer" ? DesignerView : PublisherView;

  useEffect(() => {
    if (typeof ViewToDisplay === "string") {
      navigate(ViewToDisplay, { replace: true });
    }
  }, [ViewToDisplay, navigate]);

  if (typeof ViewToDisplay === "string") {
    return null;
  }

  return (
    <ProtectedRoute UnauthenticatedView={UnauthenticatedView}>
      <QuickSearch>
        <Stack direction="row" id="app-root">
          {Features.BaseCampLayout ? (
            <>
              <Stack direction="column" width="100%" alignItems="center" pt={1}>
                <UserMenuTop />
                <Stack direction="column" width="100%" alignItems="center">
                  <Box width="100%" maxWidth={960} sx={{ padding: { xs: 0.5, md: 2 } }}>
                    <SiteBreadcrumbs />
                    <Stack direction="column">{(ViewToDisplay && <ViewToDisplay />) || children}</Stack>
                  </Box>
                </Stack>
              </Stack>
            </>
          ) : (
            <>
              <UserMenu />
              <Stack direction="column" width="100%">
                <SiteBreadcrumbs />
                <Stack direction="row">{(ViewToDisplay && <ViewToDisplay />) || children}</Stack>
              </Stack>
            </>
          )}
        </Stack>
      </QuickSearch>
    </ProtectedRoute>
  );
};

/**
 * @param {object} props
 * @param {import("react").ReactNode} [props.children]
 */
export const PublicRoute = ({ children }) => {
  return (
    <Stack direction="row" id="app-root">
      <Stack direction="column" width="100%" alignItems="center" pt={1}>
        <UserMenuTopPublic />
        <Stack direction="column" width="100%" alignItems="center">
          <Box width="100%" maxWidth={960} sx={{ padding: { xs: 0.5, md: 2 } }}>
            <Stack direction="column">{children}</Stack>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};
